import styled from "styled-components";
import {
  space,
  color,
  layout,
  typography,
  position,
  border,
  flexbox,
  variant,
} from "styled-system";
import propTypes from "@styled-system/prop-types";

const Heading = styled.h1`
  margin: 0;
  padding: 0;
  text-transform: ${props => (props.uppercase ? "uppercase" : "none")};
  text-decoration: none;
  ${space};
  ${color};
  ${layout};
  ${typography};
  ${position};
  ${border};
  ${flexbox};
  ${props =>
    variant({
      variants: {
        h1: {
          fontSize: [5, null, 7],
          lineHeight: ["32px", null, "48px"],
          fontWeight: ["light", null, "extraLight"],
          mt: props.mt ? props.mt : [2, null, 3],
        },
      },
    })}
`;

Heading.displayName = "Heading";

Heading.defaultProps = {
  fontSize: 5,
  fontWeight: "extraLight",
  color: "headlines",
};

Heading.propTypes = {
  ...propTypes.space,
  ...propTypes.color,
  ...propTypes.layout,
  ...propTypes.typography,
  ...propTypes.position,
  ...propTypes.flexbox,
};

export { Heading };
